exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product__counter {\n  display: inline-block;\n  overflow: hidden;\n  height: 36px;\n  border: 1px solid #CCC;\n  border-radius: 3px;\n  overflow: hidden;\n}\n.product__counter.topmargin {\n  margin-top: 17px;\n}\n.product__counter .product--modifycount {\n  float: left;\n  height: 36px;\n  line-height: 36px;\n  padding: 0 8px;\n  color: #0089c4;\n  background-color: #FFF;\n  cursor: pointer;\n  outline: none;\n}\n.product__counter .product--modifycount[disabled] {\n  color: #ccc;\n  cursor: disabled;\n}\n.product__counter .product--modifycount[disabled] .icon {\n  color: #CCC;\n}\n.product__counter .product--modifycount .icon {\n  color: #0089c4;\n  font-size: 16px;\n}\n.product__counter .product--count {\n  float: left;\n  height: 36px;\n  width: 2em;\n  line-height: 36px;\n  text-align: center;\n  color: #000;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/product/product-counter/product-counter.component.scss
// module id = ../../../../../src/app/components/product/product-counter/product-counter.component.scss
// module chunks = main